planner-title
  h5
    span.title { opts.title }
    span.tags-wrap
      span.tag.label.label-inverse-success.status(each="{this.status}") { label }
      span.tag.label.label-inverse-success.jobnos(each="{job_no in this.jobnos}") { job_no }
      span.tag.label.label-inverse-success.order-type(each="{this.orderType}") { label }
      span.tag.label.label-inverse-success.client(if="{opts.inputs.client_id.text != ''}") { opts.inputs.client_id.text }
      span.tag.label.label-inverse-success.user(if="{opts.inputs.user_id.text != ''}") { opts.inputs.user_id.text }
      span.tag.label.label-inverse-success.product(if="{opts.inputs.product_id.text != ''}") { opts.inputs.product_id.text }
      span.tag.label.label-inverse-success.phase-id(each="{this.phaseId}") { label }
      span.tag.label.label-inverse-success.responsible(if="{opts.inputs.responsible_id.text != ''}") { opts.inputs.responsible_id.text }
      span.tag.label.label-inverse-success.material(if="{opts.inputs.material_id.text != ''}") { opts.inputs.material_id.text }
  script(type="typescript").
    this.mixin('planner.title')
  style(scoped).
    span.title {
      margin-right: .5rem;
    }
    span.title,
    span.tags-wrap,
    span.tag {
      display: inline-block !important;
    }
  
